function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_x31_36"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  className: "st0",
  d: "M5,18c-0.8,0-1.5-0.3-2.1-0.9S2,15.9,2,15h0c-0.5,0-1-0.2-1.4-0.6C0.2,14.1,0,13.6,0,13V8h9V4 c0-0.6,0.2-1,0.6-1.4C10,2.2,10.4,2,11,2h2c0,0.2,0-0.3,0,0c0,0,0.7,0,1,0c0.3,0,1,0,1,0c0.3,0,0.8,0,1,0h0.5 c0.4,0,0.8,0.1,1.2,0.4s0.6,0.6,0.7,1l1.4,4.3C19.9,7.8,20,7.9,20,8c0,0.1,0,0.2,0,0.3V15h-3c0,0.8-0.3,1.5-0.9,2.1S14.8,18,14,18 s-1.5-0.3-2.1-0.9S11,15.9,11,15H8c0,0.8-0.3,1.5-0.9,2.1S5.8,18,5,18z M5,16c0.3,0,0.5-0.1,0.7-0.3C5.9,15.6,6,15.3,6,15 s-0.1-0.5-0.3-0.7C5.5,14.1,5.3,14,5,14s-0.5,0.1-0.7,0.3C4.1,14.5,4,14.8,4,15c0,0.3,0.1,0.5,0.3,0.7C4.5,16,4.7,16,5,16z M14,16 c0.3,0,0.5-0.1,0.7-0.3S15,15.3,15,15s-0.1-0.5-0.3-0.7C14.5,14.1,14.3,14,14,14s-0.5,0.1-0.7,0.3S13,14.8,13,15 c0,0.3,0.1,0.5,0.3,0.7C13.5,16,13.7,16,14,16z M2,10v3h0.8c0.3-0.3,0.6-0.6,1-0.7C4.2,12.1,4.6,12,5,12s0.8,0.1,1.2,0.3 c0.4,0.2,0.7,0.4,1,0.7H9v-3H2z M11,13h0.8c0.3-0.3,0.6-0.6,1-0.7c0.4-0.2,0.8-0.3,1.2-0.3s0.8,0.1,1.2,0.3c0.4,0.2,0.7,0.4,1,0.7 H18v-3h-7V13z M11,8h6.9l-1.4-4H11V8z"
}));

var SvgStorageJobPickup = function SvgStorageJobPickup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStorageJobPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storage_job_pickup.fc4c1d71.svg";
export { ForwardRef as ReactComponent };